import React from 'react';
import '../styles/LoadingIndicator.css';

const LoadingIndicator = () => {
  return (
    <div className="loading-container">
      <div className="tarot-loader">
        <div className="card-spinner"></div>
      </div>
      <p className="loading-text">Revelando los secretos del tarot...</p>
    </div>
  );
};

export default LoadingIndicator; 